// extracted by mini-css-extract-plugin
export default {"container":"DWswi5Te986cZDukNgY6","card":"QeMrfdj2xFMPkl4irRXZ","title":"wZSZKA7ESP3y1DoAojNG"};